import { getLocales } from 'assets/locales/Locale';
import { date, defaultDateTimeFormat, defaultServerDateTimeFormat, localizeDate } from 'assets/utils/data/Date';
import User from 'models/core/user/Model.User';
import Model from 'models/Model';
import accountReceivableCommentDeleteApi from './delete/Api.AccountReceivableComment.Delete';
import accountReceivableCommentListApi from './list/Api.AccountReceivableComment.List';
import accountReceivableCommentSaveApi from './save/Api.AccountReceivableComment.Save';

export default class AccountReceivableComment
  extends Model<Model.IAccountReceivableComment>({ icon: 'fas-cloud' })
  implements Model.Instance<Model.IAccountReceivableComment>
{
  id: number;
  comment: string;
  createdAtUtc: string;
  modifiedAtUtc: string;
  userId: number;
  user: User;
  accountReceivableId: number;

  get createdAtUtcUnix() {
    return date(this.createdAtUtc, defaultServerDateTimeFormat).unix();
  }
  get modifiedAtUtcUnix() {
    return this.modifiedAtUtc ? date(this.modifiedAtUtc, defaultServerDateTimeFormat).unix() : null;
  }

  constructor(
    data: Partial<Model.IAccountReceivableComment> | Utils.FormData<Model.IAccountReceivableComment>,
    language?: Locale.Languages
  ) {
    super(
      {
        user: User,
      },
      language
    );
    this.update(data);
  }
  get displayInfo(): Model.DisplayInfo {
    const { lang } = getLocales();
    return {
      id: this.id,
      title: this.user?.displayInfo?.title || lang.unknownUser,
      info: localizeDate(this.createdAtUtc, defaultDateTimeFormat),
      subtitle: this.comment,
      media: this.user?.profilePhoto?.url,
    };
  }
  async save() {
    return await accountReceivableCommentSaveApi(this);
  }
  async delete() {
    return await accountReceivableCommentDeleteApi({ id: this.id });
  }

  static async list(body?: Api.Finance.AccountReceivableComment.List.IRequest) {
    const { payload, ...rest } = await accountReceivableCommentListApi(body);
    return {
      ...rest,
      payload: payload && {
        data: payload.data?.map((it) => new AccountReceivableComment(it)),
        count: payload.count,
      },
    };
  }
}

